(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ele-birthday-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = Date.parse('2026-09-17T00:01:00+02:00');
  const end = Date.parse('2026-09-20T23:59:00+02:00');
  const clocks = new Set();
  let timer;
  let wasActive = document.documentElement.dataset.eleBirthday === 'active';
  const getRemaining = now => {
    const seconds = Math.max(0, Math.ceil((end - now) / 1000));
    return [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
  };
  const update = () => {
    const now = Date.now();
    const active = now >= start && now < end;
    document.documentElement.dataset.eleBirthday = active ? 'active' : 'inactive';
    if (!active && wasActive && now >= end) {
      const template = document.getElementById('ele-birthday-expired-template');
      if (template && !document.querySelector('.ele-birthday-expired')) {
        document.querySelector('main')?.prepend(template.content.cloneNode(true));
      }
    }
    wasActive = active;
    if (!active) { clearInterval(timer); timer = undefined; return; }
    const remaining = getRemaining(now);
    clocks.forEach(clock => clock.update(remaining));
  };
  const startClock = () => {
    update();
    if (!timer && Date.now() < end) timer = setInterval(update, 1000);
  };
  class EleBirthdayCountdown extends HTMLElement {
    connectedCallback() {
      this.digits = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-ele-${unit}]`));
      this.form = document.getElementById(this.dataset.form || '');
      this.variantChanged = event => {
        const variant = event.detail?.variant;
        this.hidden = !variant?.available || !(variant.compare_at_price > variant.price);
      };
      this.form?.addEventListener('variant:change', this.variantChanged);
      clocks.add(this);
      startClock();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this.variantChanged);
      clocks.delete(this);
    }
    update(remaining) {
      this.digits.forEach((digit, index) => {
        if (!digit) return;
        const text = String(remaining[index]).padStart(2, '0');
        if (digit.textContent !== text) digit.textContent = text;
      });
      this.querySelector('.ele-birthday-clock')?.removeAttribute('hidden');
    }
  }
  if (!customElements.get('ele-birthday-countdown')) customElements.define('ele-birthday-countdown', EleBirthdayCountdown);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) startClock(); });
  window.addEventListener('pageshow', startClock);
  startClock();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ele-buying-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ele-buying-details')) {
    customElements.define('ele-buying-details', class extends HTMLElement {
      connectedCallback() {
        this.setup = () => {
          this.detailLinks = [...this.querySelectorAll('[data-dimensions-link], [data-package-link]')];
          this.onDetailsClick = event => {
            const destination = document.getElementById(event.currentTarget.getAttribute('href').slice(1));
            const details = destination?.matches('details') ? destination : destination?.closest('details');
            const summary = details?.querySelector('summary');
            if (!summary) return;
            if (!details.open) summary.click();
            summary.focus({ preventScroll: true });
          };
          this.detailLinks.forEach(link => link.addEventListener('click', this.onDetailsClick));
          const description = document.getElementById(this.dataset.descriptionId);
          const link = this.querySelector('[data-package-link]');
          if (!description || !link) return;
          const headingPattern = /^(det får du|i denne pakke får du|pakken indeholder|pakkeløsningen indeholder|pakkeløsningen består af|pakken består af|indhold|pakkeindhold|included|what.s included)\s*[:：]?$/i;
          const contentsFrom = (node) => {
            const list = node.matches('ul,ol') ? node : node.querySelector('ul,ol');
            if (list) return [...list.children].filter(item => item.matches('li'));
            const links = [...node.querySelectorAll('a')];
            if (links.length && links.every(item => /^\d+\s*[x×]\s*/i.test(item.textContent.trim()))) return links;
            return [];
          };
          const markers = [...description.querySelectorAll('h2,h3,h4,p,strong,b,div')].filter(node => headingPattern.test(node.textContent.trim()));
          for (const marker of markers) {
            let node = marker;
            let items = [];
            for (let level = 0; level < 3 && node && node !== description; level++, node = node.parentElement) {
              let next = node.nextElementSibling;
              for (let step = 0; step < 3 && next; step++, next = next.nextElementSibling) {
                items = contentsFrom(next);
                if (items.length) break;
                if (next.textContent.trim()) break;
              }
              if (items.length) break;
            }
            if (!items.length || items.length > 12 || items.reduce((total, item) => total + item.textContent.length, 0) > 1800) continue;
            const destination = this.querySelector('[data-package-content]');
            const target = destination?.querySelector('ul');
            if (!target) return;
            target.replaceChildren(...items.map(item => {
              const copy = document.createElement('li');
              copy.textContent = item.textContent.trim();
              return copy;
            }));
            destination.hidden = false;
            break;
          }
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.setup, { once: true });
        else this.setup();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.setup);
        this.detailLinks?.forEach(link => link.removeEventListener('click', this.onDetailsClick));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ele-home-story"] && !Shopify.designMode) return;
  try {
    function eleEnhanceHomeStory(root) {
    const bodies = root.matches?.('[data-ele-story-body]') ? [root] : root.querySelectorAll('[data-ele-story-body]');
    bodies.forEach(body => {
      if (body.dataset.eleEnhanced) return;
      body.dataset.eleEnhanced = 'true';
      body.querySelectorAll('p').forEach(p => {
        const text = p.textContent.replace(/\s+/g, ' ').trim();
        if (/^Før\s+Efter$/i.test(text)) {
          p.classList.add('ele-ed-before-after');
          p.replaceChildren();
          [body.dataset.eleBefore, body.dataset.eleAfter].forEach(label => {
            const span = document.createElement('span'); span.textContent = label; p.append(span);
          });
        }
      });
      body.querySelectorAll('img').forEach(img => {
        if (!img.alt.trim()) img.alt = body.dataset.eleStoryName;
        img.loading = 'lazy';
      });
    });
  }
  eleEnhanceHomeStory(document);
  document.addEventListener('shopify:section:load', event => eleEnhanceHomeStory(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ele-product-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ele-product-delivery')) {
    customElements.define('ele-product-delivery', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-gift-card')) return;
        this.productForm = document.getElementById(this.getAttribute('form'));
        this.onVariantChange = (event) => {
          const available = Boolean(event.detail?.variant?.available);
          this.querySelectorAll('[data-delivery-available]').forEach((node) => { node.hidden = !available; });
          this.querySelectorAll('[data-delivery-unavailable]').forEach((node) => { node.hidden = available; });
        };
        this.productForm?.addEventListener('variant:change', this.onVariantChange);
      }
      disconnectedCallback() {
        this.productForm?.removeEventListener('variant:change', this.onVariantChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ele-storefront-stability"] && !Shopify.designMode) return;
  try {
    function initEleCollectionChatLayout() {
    if (document.body.dataset.eleModernPage !== 'collection') return;

    const frameSelector = 'iframe#chat-button, iframe#chat-input, iframe#mount-floating-engagement-widget';
    const mobile = window.matchMedia('(max-width: 699px)');
    const watched = new Set();
    let scheduled = false;

    function scheduleLayout() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateLayout);
    }

    const sizes = new ResizeObserver(scheduleLayout);
    const attributes = new MutationObserver(scheduleLayout);

    function updateLayout() {
      scheduled = false;
      const filter = document.querySelector('facet-floating-filter');
      const button = filter?.querySelector('button');
      const frames = [...document.querySelectorAll(frameSelector)];
      const elements = new Set([filter, button, ...frames].filter(Boolean));

      for (const element of watched) {
        if (!element.isConnected) {
          sizes.unobserve(element);
          watched.delete(element);
        }
      }

      for (const element of elements) {
        if (!watched.has(element)) {
          sizes.observe(element);
          attributes.observe(element, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
          watched.add(element);
        }
      }

      const filterStyle = filter && getComputedStyle(filter);
      const buttonRect = button?.getBoundingClientRect();
      const filterVisible = mobile.matches && buttonRect?.width > 0 &&
        filterStyle.display !== 'none' && filterStyle.visibility !== 'hidden' &&
        Number(filterStyle.opacity) > 0;

      for (const frame of frames) {
        const rect = frame.getBoundingClientRect();
        const overlaps = filterVisible && rect.width > 0 &&
          rect.left < buttonRect.right + 12 && rect.right > buttonRect.left - 12;
        const offset = `${overlaps ? Math.ceil(buttonRect.height + 12) : 0}px`;
        if (frame.style.getPropertyValue('--ele-collection-chat-offset') !== offset) {
          frame.style.setProperty('--ele-collection-chat-offset', offset);
        }
      }
    }

    new MutationObserver(scheduleLayout).observe(document.body, { childList: true, subtree: true });
    mobile.addEventListener('change', scheduleLayout);
    window.addEventListener('resize', scheduleLayout, { passive: true });
    window.addEventListener('pageshow', scheduleLayout);
    window.visualViewport?.addEventListener('resize', scheduleLayout, { passive: true });
    scheduleLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEleCollectionChatLayout, { once: true });
  } else {
    initEleCollectionChatLayout();
  }
  } catch(e) { console.error(e); }
})();

})();
